
import { Permission } from './permission.model';


export class Role {

  constructor(name?: string, description?: string, permissions?: Permission[]) {

    this.name = name;
    this.description = description;
    this.permissions = permissions;
  }

  public id: number;
  public name: string;
  public description: string;
  public usersCount: string;
  public parentRole: Role;
  public parentRoleId: number;
  public permissions: Permission[];
  public showInReport: boolean;
  public hasMobileView: boolean;
  public requireMfa: boolean;
}
